import { DesignFeature } from '../../../../types/catalog';
import Carousel from './carousel';
import { SwiperProps } from 'swiper/react/swiper-react';

function FeatureCarousel({ features }: { features: DesignFeature[]; swiperProps?: SwiperProps }) {
    return (
        <Carousel
            title="Особенности конструкции"
            items={features}
            itemRenderFn={({ url, imageUrl, description }) => (
                <a href={url} className="swiper-slide">
                    <div className="product-feature">
                        <div className="product-feature__img-cont">
                            <img className="product-feature__img" src={imageUrl} alt={description} />
                        </div>
                        <p className="product-feature__txt">{description}</p>
                    </div>
                </a>
            )}
        />
    );
}

export default FeatureCarousel;
